import { c as _c } from "react/compiler-runtime";
import type { MouseEvent } from 'react';
import styles from './SkipLink.module.scss';
type Props = {
  /**
   * The css query aiding the selection of the
   * container (main, section etc) we want to scroll to;
   */
  skipTo?: string;
};
export function SkipLink(t0) {
  const $ = _c(2);
  const {
    skipTo: t1
  } = t0;
  const skipTo = t1 === undefined ? "main:first-of-type" : t1;
  let t2;
  if ($[0] !== skipTo) {
    const onClick = function onClick(event) {
      event.preventDefault();
      const container = document.querySelector(skipTo);
      if (container) {
        container.tabIndex = -1;
        container.focus();
        setTimeout(() => container.removeAttribute("tabindex"), 1000);
      }
    };
    t2 = <button className={`${styles.skipLink} heading4 outline-inside`} type="button" onClick={onClick}>Navigation überspringen</button>;
    $[0] = skipTo;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  return t2;
}